import React, { useState } from 'react'
import { Box, Pagination, RowsPerPageType } from '@node-space/ui-components'
import { useGetLedgerWalletTransactions } from 'hooks/queries/Ledger/useGetLedgerWalletTransactions'
import { usePaginationPagingPersist } from 'hooks/usePaginationPagingPersist'
import { TransactionTypes } from 'types/ledger/ledgerWalletTransactions'
import { Portfolio } from 'types/rewards'
import { RewardsSummary } from './RewardsSummary'
import { RewardsTransactionsList } from './RewardsTransactionsList'

interface RewardsManageProps {
  userPortfolios: Portfolio[]
}

export const RewardsManage = ({ userPortfolios }: RewardsManageProps) => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState<RowsPerPageType>(10)

  const handleChangePage = (newPage: number) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (newRowsPerPage: RowsPerPageType) => {
    setRowsPerPage(newRowsPerPage)
    setPage(0)
  }

  const { data: transactionsData, isLoading: isLoadingTransactions } =
    useGetLedgerWalletTransactions({
      type: TransactionTypes.REWARDS,
      page,
      size: rowsPerPage,
    })

  const transactions = transactionsData?.content ?? []

  const { paging } = usePaginationPagingPersist(transactionsData?.pagination)
  const showPagination =
    transactions.length > 0 && paging?.total / rowsPerPage > 1 && !isLoadingTransactions

  return (
    <Box flexCol gapY={24}>
      <RewardsSummary userPortfolios={userPortfolios} />
      <RewardsTransactionsList transactions={transactions} loading={isLoadingTransactions} />

      {showPagination && (
        <Pagination
          testId="rewards-manage-pagination"
          page={page}
          rowsPerPage={rowsPerPage}
          total={paging?.total ?? 0}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      )}
    </Box>
  )
}
